// extracted by mini-css-extract-plugin
export default {"card":"BuffCard_card__K8iuq","line":"BuffCard_line__8GKW4","buff_name":"BuffCard_buff_name__ojl8f","name":"BuffCard_name__G9ags","selected_line":"BuffCard_selected_line__sNn-L"};